export default "__VITE_ASSET__Bu$I_0Bu__"